/**
 * Section heading used with carousel navigation (acf.header_with_arrows).
 */

import { OpsiHtmlContent } from "../utils/OpsiHtmlContent";
import { hasHtmlContent, OPSI_PART_SPACING } from "../utils/opsiHelpers";

export const OpsiHeaderWithArrows = ({
  data,
  className = `opsi-header-with-arrows ${OPSI_PART_SPACING}`,
}) => {
  const text = typeof data === "string" ? data : "";
  const isPlainText = text && !/<[a-z][\s\S]*>/i.test(text);

  if (!hasHtmlContent(text)) {
    return null;
  }

  return (
    <header className={className} data-opsi-part="header-with-arrows">
      {isPlainText ? (
        <h2>{text}</h2>
      ) : (
        <OpsiHtmlContent html={text} as="h2" />
      )}
      {/* Arrow controls will be wired when slider styles are supplied. */}
    </header>
  );
};
